import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { LsbApi, RequestStrategyEnum, type GetSpecialOffersRequest, type GetSpecialOffersResponse, type WithSignal } from '@shared/api';

const getSpecialOffersEffect = createEffect(({ signal, ...request }: WithSignal<GetSpecialOffersRequest> = {}) =>
  LsbApi.getSpecialOffers(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: GetSpecialOffersResponse[] }>({ total: 0, data: [] })
  .on(getSpecialOffersEffect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getSpecialOffersEffect.pending, (_, data) => data)
  .on(getSpecialOffersEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getSpecialOffersEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getSpecialOffersEffect, () => null)
  .on(getSpecialOffersEffect.fail, () => 'Something went wrong while fetching Special Offers. Please try again.')
  .on(getSpecialOffersEffect.done, () => null)
  .reset(clearEvent);

const getSpecialOffersApi = ApiUtils.wrapperApi(getSpecialOffersEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getSpecialOffersApi.cancel());

export const $specialOffersStore = {
  events: {
    getSpecialOffers: getSpecialOffersApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
